import * as React from 'react';
import { classes, st } from './RadioButtonGroup.st.css';
import { RadioButton } from '../RadioButton';
import {
  RadioButtonGroupProps,
  RadioButtonGroupDefaultProps,
  RadioButtonGroupLayout,
} from './types';
import { Fieldset } from '../internal/Fieldset';
import uniqueId from '../../common/uniqueId';

/** radio button group */
export class RadioButtonGroup extends React.Component<RadioButtonGroupProps> {
  private readonly _errorMessageId: string;
  static displayName = 'RadioButtonGroup';
  static defaultProps: RadioButtonGroupDefaultProps = {
    value: '',
    layout: RadioButtonGroupLayout.Vertical,
  };

  constructor(props) {
    super(props);
    this._errorMessageId = uniqueId('error-message');
  }

  render() {
    const {
      label,
      layout,
      error,
      newErrorMessage,
      disabled,
      errorText,
      className,
      theme,
      withSpacing,
      fluid,
      name,
      lang,
      ariaLabelledBy,
    } = this.props;

    const stStates = { disabled, layout, withSpacing, newErrorMessage, fluid };
    const isErrorMessageProvided = errorText && errorText.length > 0;

    return (
      <Fieldset
        errorMessage={newErrorMessage && error && errorText}
        errorMessageId={this._errorMessageId}
        data-hook={this.props['data-hook']}
        className={st(classes.root, stStates, className)}
        label={label}
        lang={lang}
        aria-labelledby={ariaLabelledBy}
      >
        <div className={classes.wrapper}>
          {React.Children.map(
            this.props.children,
            (child: RadioButton, idx: number) => {
              if (!React.isValidElement(child)) {
                return null;
              }
              return (
                <>
                  {React.cloneElement(child, {
                    key: idx,
                    disabled: disabled || child.props.disabled,
                    className: st(
                      classes.radioButtonItem,
                      child.props.className,
                    ),
                    name: child.props.name || name,
                    error,
                    theme,
                    checked:
                      child.props.value === this.props.value &&
                      (!newErrorMessage || !isErrorMessageProvided),
                    onChange: (e) => {
                      if (e.value !== this.props.value) {
                        this.props.onChange(e.value as string);
                      }
                    },
                  })}
                </>
              );
            },
          )}
        </div>
        {error &&
          !!errorText &&
          !disabled &&
          (!newErrorMessage || !isErrorMessageProvided) && (
            <span className={classes.error}>{errorText}</span>
          )}
      </Fieldset>
    );
  }
}
